export const toDateString = (date: Date) => {
  return `${date.getDate()}.${date.getMonth() + 1}.`;
};
